import { useEffect, useState } from 'react';
import { Checkbox } from '@pmi/dsm-react';
import styles from './FilterCustomSelect.module.scss';
import RenderHtml from '../../../../../shared/components/RenderHtml';
import { Option } from '../index';

export interface CustomItemListProps {
  items: { [key: string]: Option[] };
  selected: any[];
  onCheck: (items: any[]) => void;
}

export default function CustomItemList({
  items,
  onCheck,
  selected,
}: CustomItemListProps) {
  const [selectedItems, setSelectedItems] = useState<Option[]>(selected);
  const isChecked = (item: Option) =>
    selectedItems.some((s) => item.value === s.value);

  const toggleSelectedItem = (item: Option) => {
    let clone = [...selectedItems];
    if (isChecked(item)) {
      clone = clone.filter((o) => o.value !== item.value);
    } else {
      clone.push(item);
    }
    setSelectedItems(clone);
  };

  const checkboxList = (options: Option[] | Option) => {
    function renderLabel(label: string) {
      return (
        <RenderHtml html={label} tag="span" className="d-block itemLabel" />
      );
    }
    if (!Array.isArray(options)) {
      const item = { ...options };
      return (
        <li
          className={`${isChecked(item) ? 'active ' : ''}${
            styles.customSelectorBlockItem
          }`}
          key={`pgroup-${item.value}`}
          data-item={item.value}
        >
          <Checkbox
            id={`checkbox-${item.value}-${item.groupKey}`}
            key={`checkbox-${item.value}-${item.groupKey}`}
            value={item.value}
            label={renderLabel(item.label)}
            labelClass={styles.customSelectorBlockItemLabel}
            onChange={() => {
              toggleSelectedItem(item);
            }}
            checked={isChecked(item)}
          />
        </li>
      );
    }

    return (
      <ul className={styles.customSelectorBlockItems}>
        {options.map((item: Option) => (
          <li
            className={`${isChecked(item) ? 'active ' : ''}${
              styles.customSelectorBlockItem
            }`}
            key={`pgroup-${item.value}`}
            data-item={item.value}
          >
            <Checkbox
              id={`checkbox-${item.value}-${item.groupKey}`}
              key={`checkbox-${item.value}-${item.groupKey}`}
              value={item.value}
              label={renderLabel(item.label)}
              labelClass={styles.customSelectorBlockItemLabel}
              onChange={() => {
                toggleSelectedItem(item);
              }}
              checked={isChecked(item)}
            />
          </li>
        ))}
      </ul>
    );
  };

  useEffect(() => {
    onCheck(selectedItems);
  }, [selectedItems]);

  return (
    <>
      {Object.keys(items).map((text: string, index: number) => {
        if (items[text].length === 0) {
          return null;
        }
        if (Array.isArray(items[text])) {
          return (
            <li key={`block-${index.toString()}`}>
              <strong className={styles.customSelectorBlockTitle}>
                {text}
              </strong>
              {checkboxList(items[text])}
            </li>
          );
        }
        return checkboxList(items[text]);
      })}
    </>
  );
}
